const WEB_API_UPLOAD_ROUTE = 'wikicommunity$webapiupload'

export type WebUploadImagePayload = {
  uid: string
  base64: string
  name: string
  languageCode: string
  countryCode: string
}

/** 通过聚合接口上传 web 页面图片。 */
export const uploadWebImage = async (images: WebUploadImagePayload[]) => {
  const api = useEnvApi()

  return await request({
    baseURL: api.homeClient,
    url: `${WIKIBITWEBV1}/invoke-v3/v3`,
    method: 'POST',
    data: {
      images,
    },
    headers: {
      Routes: WEB_API_UPLOAD_ROUTE,
    },
  })
}

/** 判断当前环境是否可以访问 Google。 */
export const pingGoogle = async () => {
  const GOOGLE_PING_URL = 'https://www.google.com/generate_204'
  const GOOGLE_PING_TIMEOUT = 5000
  const abortController = new AbortController()
  const timeoutId = setTimeout(() => abortController.abort(), GOOGLE_PING_TIMEOUT)

  try {
    await fetch(GOOGLE_PING_URL, {
      method: 'GET',
      mode: 'no-cors',
      cache: 'no-store',
      signal: abortController.signal,
    })

    return true
  } catch {
    return false
  } finally {
    clearTimeout(timeoutId)
  }
}

export interface BrandPageUrlItem {
  traderCode: string
  alias: string
}

/** 批量获取品牌页面 URL */
export const getBrandPageUrlBatch = (traderCodes: string[]) => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: '/api/v4/bit/web/brand/page-url/batch',
    method: 'POST',
    data: {
      traderCodes,
    },
  }

  return import.meta.server
    ? useServerFetch<BrandPageUrlItem[]>(requestConfig)
    : request<BrandPageUrlItem[]>(requestConfig)
}
